import { GET_SINGLE_PROMO} from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_SINGLE_PROMO:
            return action.payload;
        default:
            return state;
    }
}
